/**
 * Статусы теста
 */
export enum ETestStatus {
  NotStarted = 'not_started',
  InProgress = 'in_progress',
  OnReview = 'on_review',
  TestPassed = 'test_passed',
  TestFailed = 'test_failed',
  WaitingForDocuments = 'waiting_for_documents',
  InReserve = 'in_reserve',
  Approved = 'approved',
  Rejected = 'rejected',
}
